import { Citation } from '#/api'
import { PreviewType } from './FilePreview.types'
import { FeatureFlag, agentHasFeature } from '#/constants/agentFeatures'

export const GetPreviewType = (fileExtension: string | null, url?: string | null, agent?: string): PreviewType => {
  if (!agentHasFeature(FeatureFlag.PdfPreview, agent)) {
    return PreviewType.DEFAULT
  }

  if (!url) {
    return PreviewType.DEFAULT
  }

  if (!fileExtension) {
    return PreviewType.DEFAULT
  }

  const normalizeExtension = fileExtension.trim().toLowerCase()
  switch (normalizeExtension) {
    case 'pdf':
      return PreviewType.PDF
    default:
      return PreviewType.DEFAULT
  }
}

export const TryGetFileExtension = (fileName?: string | null): string | null => {
  if (!fileName) {
    return null
  }

  return fileName.split('.').pop()?.toLowerCase() ?? null
}

export const GetDefaultAgent = (): string => {
  return 'unknown_agent'
}

export const GetDefaultCitation = (): Citation => {
  return {
    chunk_id: '',
    content: '',
    filepath: '',
    id: '',
    metadata: '',
    reference: '',
    reindex_id: '',
    title: '',
    url: '',
    part_index: 0,
    documentNumber: '',
    fileExtension: '',
    languageCode: '',
    page_from: '',
    page_to: '',
    partId: '',
    revision: '',
    section: ''
  }
}
